import ReactDOM from "react-dom/client";
import React, { ReactNode, useEffect, useState } from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";
// @ts-ignore */}
import Layout from "./pages/layout/Layout";
import NoPage from "./pages/NoPage";
import Chat from "./pages/chat/Chat";
import Login from "./pages/login/Login";
import { createTheme } from "@mui/material";
import ThemeProvider from "./theme/ThemeProvider";
// import BulkUpload from "./components/upload/Upload";
import { Provider, useDispatch, useSelector } from "react-redux";
import appStore from "./store/appStore";
import { RootState } from "./store/appStore";
import DefaultLayout from "./components/defaultLayout/DefaultLayout";
import Homepage from "./pages/homepage/Homepage";
import CommonSnackbar from "./components/CommonSnackbar/CommonSnackbar";
import Loader from "./components/loader/loader";
import { AppStateProvider } from "./state/AppProvider";
import ErrorBoundary from "./components/error/ErrorBoundary";
import frontendSettings from "../frontend_settings.json";
import Attributes from "./pages/attributes/Attributes";
import UploadNew from "./pages/upload/UploadNew";
import PowerBI from "./pages/powerBi/powerBI";
import PowerBIReport from "./pages/powerBi/powerBI";
import UserManagement from "./pages/userManagement/userManagement";
import ProjectManagement from "./pages/projectManagement/projectManagement";
import ProjectDetail from "./pages/projectManagement/ProjectDetail";
import Verify from "./pages/verify/verify";
import ResetPassword from "./pages/resetPassword/resetPassword";
import Opportunities from "./pages/opportunities/Opportunities";
import OpportunityDetail from "./pages/opportunities/OpportunityDetail";
import Scenarios from "./pages/scenarios/Scenarios";
import ScenarioDetail from "./pages/scenarios/ScenarioDetail";
import ContractReview from "./pages/contractReview/ContractReview";
import Negotiations from "./pages/negotiations/Negotiations";
import NegotiationsList from "./pages/negotiations/NegotiationsList";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer } from "react-toastify";

initializeIcons();
interface PrivateRouteProps {
	children: ReactNode;
}
export default function App() {
	// Using our custom ThemeProvider that reads from UIconfig.config.palette
	return (
		<AppStateProvider>
			<Provider store={appStore}>
				<BrowserRouter>
					<ThemeProvider>
						<Loader />
						<ErrorBoundary>
							<Routes>
							<Route
									path="/reset-password"
									element={<ResetPassword />}
								/>
								{/* Login route - no defaultLayout */}
								<Route path="/" element={<Login />} />
								<Route path="/verify" element={<Verify />} />
								{/* Routes with defaultLayout */}
								<Route
									path="/homepage"
									element={
										 <PrivateRoute>
											<DefaultLayout />
										 </PrivateRoute>
									}
								>
									<Route
										index
										element={
											<PrivateRoute>
												<Homepage />
											 </PrivateRoute>
										}
									/>
									<Route
										path="intelligence"
										element={
											 <PrivateRoute>
												<Chat />
											 </PrivateRoute>
										}
									/>
									<Route
										path="management"
										element={
											 <PrivateRoute>
												<UploadNew />
											 </PrivateRoute>
										}
									/>
									<Route
										path="attributes"
										element={
											<PrivateRoute>
												<Attributes />
											 </PrivateRoute>
										}
									/>
									<Route
										path="comparison"
										element={
											<PrivateRoute>
												<PowerBIReport />
											 </PrivateRoute>
										}
									/>
									<Route
										path="scenarios"
										element={
											<PrivateRoute>
												<Scenarios />
											</PrivateRoute>
										}
									/>
									<Route
										path="scenarios/:id"
										element={
											<PrivateRoute>
												<ScenarioDetail />
											</PrivateRoute>
										}
									/>
									<Route
										path="opportunities"
										element={
											<PrivateRoute>
												<Opportunities />
											</PrivateRoute>
										}
									/>
									<Route
										path="opportunities/:id"
										element={
											<PrivateRoute>
												<OpportunityDetail />
											</PrivateRoute>
										}
									/>
									<Route
										path="contract-review"
										element={
											<PrivateRoute>
												<ContractReview />
											</PrivateRoute>
										}
									/>
									<Route
										path="negotiations"
										element={
											<PrivateRoute>
												<NegotiationsList />
											</PrivateRoute>
										}
									/>
									<Route
										path="negotiations/:id"
										element={
											<PrivateRoute>
												<Negotiations />
											</PrivateRoute>
										}
									/>
									<Route
										path="user"
										element={
											<PrivateRoute>
												<UserManagement />
											 </PrivateRoute>
										}
									/>
									<Route
										path="project"
										element={
											<PrivateRoute>
												<ProjectManagement />
											 </PrivateRoute>
										}
									/>
									<Route
										path="project/:id"
										element={
											<PrivateRoute>
												<ProjectDetail />
											</PrivateRoute>
										}
									/>
								</Route>
								<Route
									path="*"
									element={
										 <PrivateRoute>
											<NoPage />
										 </PrivateRoute>
									}
								/>
							</Routes>
						</ErrorBoundary>
						<CommonSnackbar />
						{/* <ToastContainer
							position="bottom-right"
							autoClose={5000}
							hideProgressBar={false}
						/> */}
					</ThemeProvider>
				</BrowserRouter>
			</Provider>
		</AppStateProvider>
	);
}
// PrivateRoute to protect routes based on authentication
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
	const isAuthenticated = useSelector(
		(state: RootState) => state.auth.isAuthenticated,
	);
	return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<App />,
);
